import IconGoal from "~src/components/icons/IconGoal.vue";
import IcoNownGoal from "~src/components/icons/IcoNownGoal.vue";
import IconYellowCard from "~src/components/icons/IconYellowCard.vue";
import IconTwoYellowRed from "~src/components/icons/IconTwoYellowRed.vue";
import IconInstead from "~src/components/icons/IconInsteadNew.vue";
import IconPenalty from "~src/components/icons/IconPenalty.vue";
import IconAssist from "~src/components/icons/IconAssist.vue";
import IconPenalty1 from "~src/components/icons/IconPenalty1.vue";
import IconCheckVar from "~src/components/icons/IconCheckVar.vue";
import IconRedCard from "~src/components/icons/IconRedCard.vue";
import IconSubstituted from "~src/components/icons/IconSubstitutedNew.vue";
import IconPenaltyMiss from "~src/components/icons/IconPenaltyMiss.vue";
import IconInjury from "~src/components/icons/IconInjury.vue";

const STATUS_ABNORMAL = 0;
const STATUS_NOT_STARTED = 1;
const STATUS_FIRST_HALF = 2;
const STATUS_HALF_TIME = 3;
const STATUS_SECOND_HALF = 4;
const STATUS_OVERTIME = 5;
const STATUS_OVERTIME_DEPRECATED = 6;
const STATUS_PENALTY_SHOOT_OUT = 7;
const STATUS_END = 8;
const STATUS_DELAY = 9;
const STATUS_INTERRUPT = 10;
const STATUS_CUT_IN_HALF = 11;
const STATUS_CANCEL = 12;
const STATUS_TO_BE_DETERMINED = 13;

export = {
  STAGE_MODE_LEAGUE: 1,
  STAGE_MODE_CUP: 2,

  // football
  STATUS_ABNORMAL,
  STATUS_NOT_STARTED,
  STATUS_FIRST_HALF,
  STATUS_HALF_TIME,
  STATUS_SECOND_HALF,
  STATUS_OVERTIME,
  STATUS_OVERTIME_DEPRECATED,
  STATUS_PENALTY_SHOOT_OUT,
  STATUS_END,
  STATUS_DELAY,
  STATUS_INTERRUPT,
  STATUS_CUT_IN_HALF,
  STATUS_CANCEL,
  STATUS_TO_BE_DETERMINED,
  LIST_STATUS_PLAYING: [
    STATUS_FIRST_HALF,
    STATUS_HALF_TIME,
    STATUS_SECOND_HALF,
    STATUS_OVERTIME,
    STATUS_OVERTIME_DEPRECATED,
    STATUS_PENALTY_SHOOT_OUT,
  ],
  LIST_STATUS_RESULT: [
    STATUS_FIRST_HALF,
    STATUS_HALF_TIME,
    STATUS_SECOND_HALF,
    STATUS_OVERTIME,
    STATUS_OVERTIME_DEPRECATED,
    STATUS_PENALTY_SHOOT_OUT,
    STATUS_END,
  ],
  MATCH_STATUS_TEXT: {
    0: "Bất thường",
    1: "Chưa bắt đầu",
    2: "Hiệp 1",
    // 3: "Nghĩ giữa hiệp",
    3: "HT",
    4: "Hiệp 2",
    5: "Hiệp phụ",
    6: "Hiệp phụ",
    7: "Pen",
    8: "Kết thúc",
    9: "Trì hoãn",
    10: "Gián đoạn",
    11: "Cắt một nửa",
    12: "Hủy bỏ",
    13: "Chưa xác định",
  },

  // listIncidents
  INCIDENT_LIST: [
    { type: 1, label: "Bàn thắng", icon: IconGoal },
    { type: 17, label: "Phản lưới nhà", icon: IcoNownGoal },
    { type: 3, label: "Thẻ vàng", icon: IconYellowCard },
    { type: 10, label: "Thay vào", icon: IconInstead },
    { type: 8, label: "Penalty", icon: IconPenalty },
    { type: 1111, label: "Kiến tạo", icon: IconAssist }, // type === 1; assist1.id != player.id
    { type: 29, label: "Phạt đền", icon: IconPenalty1 },
    { type: 28, label: "Check var", icon: IconCheckVar },
    { type: 4, label: "Thẻ đỏ", icon: IconRedCard },
    { type: 9, label: "Thay ra", icon: IconSubstituted },
    { type: 15, label: "Thẻ vàng thứ hai", icon: IconTwoYellowRed },
    { type: 16, label: "Đá hỏng phạt đền", icon: IconPenaltyMiss },
    { type: 19, label: "Chấn thương", icon: IconInjury },
  ]
};
